/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Button } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useChangePassword } from "../../services/auth-api";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";

export default function ChangePassword() {
  const navigate = useNavigate();
  const {
    mutate: changePassword,
    data: changePasswordRes,
    isPending: changingPassword,
  } = useChangePassword();

  useEffect(() => {
    if (changePasswordRes) {
      navigate("/");
    }
  }, [changePasswordRes]);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { oldPassword: "", newPassword: "", verifyNewPassword: "" },
  });
  const generalFieldProps = { control, errors };
  const verificationRules = {
    oldPassword: {
      required: "Please Enter Old Password",
    },
    newPassword: { required: "Please Enter New Password" },
    verifyNewPassword: { required: "Please Verify New Password" },
  };
  const submitInfo = (data) => {
    const payload = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    };
    changePassword(payload);
  };
  return (
    <>
      {changingPassword ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Profile", link: Paths.profile },
            { text: "Change Password", isCurrentPage: true },
          ]}
        />
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Card style={{ width: "500px" }}>
            <CardHeader>Change Password</CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit(submitInfo)}>
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="oldPassword"
                  label="Old Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.oldPassword}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="newPassword"
                  label="New Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.newPassword}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="verifyNewPassword"
                  label="Verify New Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.verifyNewPassword}
                />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: "12px",
                  }}
                >
                  <Button type="submit">Update Password</Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
